import CustomCard from '../../../../components/CustomCard';
import CustomGenericTittleIconDataChip from '../../../../components/CustomGenericTittleIconDataChip';
import {
    DownloadIcon,
    QrTitle
} from '../../../../components/buttons/IconButtons';
import {QRCode} from "react-qrcode-logo";
import React from "react";
import ButtonAction from "../../../../components/buttons/ButtonAction";
/**
 * @Email kpozos@ibl.mx
 * @Author Karen Yunuen Pozos Arias
 * @JobTitle FullStack
 *
 * @component QrCard
 * @description A card that displays a qr code to visitor.
 *
 */
const QrCard = ({ t, data, handleDownload }) => {
    return (
        <>
            <CustomCard  classCard={`card-border-8px minh-235px`} classContent={'p-0'}>
                <div className="row my-2">
                    <CustomGenericTittleIconDataChip  title={ t('access_qr_code')} className={"mt-2"}  Icon={QrTitle} border={false} />
                </div>
                <div className={"border-bottom-shades-300"}/>

                <div className={'col-12 mt-4'}>
                    <div className={'text-center'}>
                        <p className={'ibl-font-w-600 fs-14px'}>{t('your_access_pass')}</p>
                        <p className={'fs-14px'}>{t('show_this_code_at_entrance_for_quick_check_in')}</p>
                    </div>
                    <div className='d-flex justify-content-center mt-3'>
                        <div className='d-flex justify-content-center align-items-center w-100 h-100 qr-code-box'>
                            <QRCode ecLevel={'H'} value={data} size={420} renderAs='canvas' />
                        </div>
                    </div>
                    <div className="d-flex justify-content-center my-4">
                        <ButtonAction
                            id='btn_qc_download_qr'
                            name='download_qr'
                            className='btn-icon-secondary-600-800 rsvp-dropdown'
                            Icon={DownloadIcon}
                            splitName={false}
                            disabled={false}
                            onClick={handleDownload}
                        />
                    </div>
                </div>
            </CustomCard>
        </>
    );
};

export default QrCard;
